import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "../components/_app/Layout";

import LoginPage from "../pages/auth/LoginPage";
import OtpVerification from "../pages/auth/OtpVerification";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";

import NotificationSection from "../pages/profile/NotificationSection";
import ProfileSection from "../pages/profile/ProfileSection";

import AddUser from "../pages/users/AddUser";
import UserList from "../pages/users/UserList";

import RoleManagement from "../pages/role/RoleManagement";
import FrontEndProcessing from "../pages/FrontEndProcessing";
import ProtectedRoute from "../ProtecedRoutes/ProtectedRoute";
import CallCenterInboxPage from "../pages/call-center/CallCenterInboxPage";
import CallCenterCampaignsPage from "../pages/call-center/CallCenterCampaignsPage";
import CallCenterAgentWorkspacePage from "../pages/call-center/CallCenterAgentWorkspacePage";
import CallCenterTicketsListPage from "../pages/call-center/CallCenterTicketsListPage";
import CallCenterSettingsPage from "../pages/call-center/CallCenterSettingsPage";
import CallCenterAnalyticsPage from "../pages/call-center/CallCenterAnalyticsPage";
const Router = () => {
  const [user] = useState(null);

  const loggedIn = window.localStorage.getItem("isLoggedIn");

  if (!window.localStorage.getItem("accessToken")) {
    return <LoginPage />;
  }
  return (
    <Routes>
      <Route path="/front1234end" element={<FrontEndProcessing />} />
      <Route
        path="/"
        element={
          loggedIn ? (
            <Layout>
              <UserList />
            </Layout>
          ) : (
            <LoginPage />
          )
        }
      />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/otp-verify" element={<OtpVerification />} />


      <Route
        path="/call-center/inbox"
        element={
          <Layout>
              <CallCenterInboxPage />
          </Layout>
        }
      />
      <Route
        path="/call-center/campaigns"
        element={
          <Layout>
              <CallCenterCampaignsPage />
          </Layout>
        }
      />
      <Route
        path="/call-center/tickets"
        element={
          <Layout>
              <CallCenterTicketsListPage />
          </Layout>
        }
      />
      <Route
        path="/call-center/agent-workspace"
        element={
          <Layout>
              <CallCenterAgentWorkspacePage />
          </Layout>
        }
      />
      <Route
        path="/call-center/settings"
        element={
          <Layout>
              <CallCenterSettingsPage />
          </Layout>
        }
      />
      <Route
        path="/call-center/analytics"
        element={
          <Layout>
              <CallCenterAnalyticsPage />
          </Layout>
        }
      />

      <Route
        path="/all-users"
        element={
            <Layout>
              <UserList />
            </Layout>
        }
      />

      <Route
        path="/add-user"
        element={
            <Layout>
              <AddUser />
            </Layout>
        }
      />
      <Route
        path="/add-user/:userId"
        element={
            <Layout>
              <AddUser />
            </Layout>
        }
      />

      <Route
        path="/user-profile"
        element={
          <Layout>
            <ProfileSection />
          </Layout>
        }
      />
      <Route
        path="role-management"
        element={
          <Layout>
            <RoleManagement />
          </Layout>
        }
      />
    </Routes>
  );
};

export default Router;
